var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6580_5074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7675 4.36628C0.5723 4.17102 0.5723 3.85443 0.7675 3.65917L3.9495 0.477186C4.14478 0.281926 4.46136 0.281926 4.65663 0.477186C4.85189 0.672446 4.85189 0.989036 4.65663 1.1843L1.8282 4.01273L4.65663 6.84115C4.85189 7.03641 4.85189 7.35299 4.65663 7.54825C4.46136 7.74352 4.14478 7.74352 3.9495 7.54825L0.7675 4.36628ZM13.9316 4.51273L1.1211 4.51273L1.1211 3.51273L13.9316 3.51273L13.9316 4.51273Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6580_5074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 8,
    fill: "white",
    transform: "translate(14 8) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft);
export default __webpack_public_path__ + "static/media/ic_arrow_left.9cd180ed945cd569bbf00ca1fbae5abd.svg";
export { ForwardRef as ReactComponent };